<template>
  <div class="captcha-ui">
    <div data-smart-captcha />
    <slot />
    <ShieldSmartCaptcha />
  </div>
</template>

<script>
import ShieldSmartCaptcha from './ShieldSmartCaptcha.vue';

export default {
  name       : 'YandexSmartCaptcha',
  components : {
    ShieldSmartCaptcha
  },
  props: {
    sitekey: {
      type     : String,
      required : true
    }
  },

  data() {
    return {
      captchaScriptId : '__SMART_CAPTCHA_SCRIPT',
      widgetId        : null,
      isRender        : false
    };
  },

  watch: {
    isRender(value) {
      if (value) {
        this.$emit('render');
      }
    }
  },

  mounted() {
    this.loadYandexCaptchaScript();
  },

  beforeDestroy() {
    if (window.smartCaptcha) {
      window.smartCaptcha.destroy(this.widgetId);
    }
  },

  methods: {
    loadYandexCaptchaScript() {
      if (document.getElementById(this.captchaScriptId)) {
        // Если скрипт уже загружен, просто вызываем captchaApiLoaded
        this.captchaApiLoaded();
        return;
      }

      const script = document.createElement('script');
      script.id = this.captchaScriptId;
      script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onYandexCaptchaLoad';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      window.onYandexCaptchaLoad = this.captchaApiLoaded;
    },

    captchaApiLoaded() {
      const elSmartCaptcha = this.$el ? this.$el.querySelector('[data-smart-captcha]') : null;

      if (!window.smartCaptcha || !elSmartCaptcha) {
        setTimeout(() => {
          this.captchaApiLoaded();
        }, 1000);
        return;
      }

      try {
        this.widgetId = window.smartCaptcha.render(elSmartCaptcha, {
          sitekey    : this.sitekey,
          hl         : 'ru',
          invisible  : true,
          // Скрываем стандартный блок с уведомлением об обработке данных.
          // И отображаем кастомный компонент ShieldSmartCaptcha
          hideShield : true,
          callback   : () => {
            this.setProcessExecute(false);
          }
        });

        window.smartCaptcha.subscribe(
          this.widgetId,
          'success',
          (token) => {
            this.setProcessExecute(false);
            this.$emit('verify', token);
          }
        );

        window.smartCaptcha.subscribe(
          this.widgetId,
          'network-error',
          () => {
            this.onErrors();
            this.$emit('network-error');
          }
        );

        window.smartCaptcha.subscribe(
          this.widgetId,
          'javascript-error',
          () => {
            this.onErrors();
            this.$emit('javascript-error');
          }
        );

        window.smartCaptcha.subscribe(
          this.widgetId,
          'token-expired',
          () => {
            this.onErrors();
            this.$emit('expired');
          }
        );

        window.smartCaptcha.subscribe(
          this.widgetId,
          'challenge-hidden',
          () => {
            this.isRender = true;
            this.setProcessExecute(false);
          }
        );

        this.isRender = true;
      } catch {
        this.onErrors();
      }
    },

    reset() {
      if (!window.smartCaptcha) {
        return;
      }

      try {
        window.smartCaptcha.reset(this.widgetId);
      } catch {
        this.onErrors();
      }
    },

    execute() {
      if (!window.smartCaptcha) {
        return;
      }

      const token = window.smartCaptcha.getResponse(this.widgetId);
      if (token) {
        this.setProcessExecute(false);
        this.$emit('verify', token);

        return;
      }

      try {
        this.setProcessExecute(true);
        window.smartCaptcha.execute(this.widgetId);
      } catch {
        this.onErrors();
      }
    },

    onErrors() {
      // При возникновении ошибки - прокидываем флаг,
      // что капча отрендерилась и что проверка пользователя завершена,
      // чтобы избежать бесконечного лоадера
      if (!this.isRender) {
        this.isRender = true;
      }
      this.setProcessExecute(false);
    },

    setProcessExecute(value) {
      this.$emit('process-execute', value);
    }
  }
};
</script>
